export const CATALOG_COLORS = {
  1: '#6366f1', 2: '#3b82f6', 3: '#ef4444',
  4: '#8b5cf6', 5: '#f97316', 6: '#22c55e',
  7: '#EAB308', // active_fires — jaune (au lieu de #ec4899 rose)
};
export const SERVICE_LABELS = {
  auth:                  'Authentification',
  weather:               'Météo',
  historic_fire_service: 'Historiques des feux',
  physical_model:        'Modèle physique',
//   dfci_service:          'Analyse terrain',
//   vegetation_service:    'Végétation',
  display_layers_service: 'Couches terrain',
  active_fires:   'Points chauds',
};
export const LAYER_LABELS = {
  // Météo
  cloud:                'Couverture nuageuse',
  precipitation_1h:     'Précipitations horaires cumulées',
  total_precipitation:  'Précipitation totale',
  pr2msl:               'Pression au niveau de la mer',
  relative_humidity:    'Humidité relative',
  wind_direction:       'Direction du vent',
  wind_speed:           'Vitesse du vent',
  wind_gust:            'Vitesse des rafales de vent',
  soil_moisture:        'Humidité du sol',
  temperature:          'Température',

  // Authentification
  login_secufire:   'Connexion Secufire Action',
  login_dashboard:  'Connexion tableau de bord',

  // Modèle physique
  dynamic:    'Propagation réelle',
  simulation: 'Propagation simulée',
  historic:   'Historique d\'événements',

  // Couches terrain
  dfmc:                  'Humidité des combustibles morts',
  baresoil:              'Sol nu',
  shrubland:             'Strate arbustive',
  grassland:             'Strate herbacée',
  cropland:              'Zones agricoles',
  lai:                   'Indice de surface foliaire',
  height:                'Hauteur de végétation',
  biomass:               'Biomasse',
  'total fuel load':     'Charge totale de combustible',
  coniferous:            'Forêts de conifères',
  broadleaf:             'Forêts de feuillus',
  mixed:                 'Forêt mixte',
  pine:                  'Pin',
  oak:                   'Chêne',
  dfci:                  'Quaddrillage DFCI',
  dem:                   'Modèle numérique du terrain',
  road:                  'Routes/ chemins d\'accès',
  railways:              'Chemins de fer',
  'electrical lines':    'Lignes électriques',
  'electrical stations': 'Stations électriques',
  'gaz lines':           'Lignes principales de gaz',
  'gaz stations':        'Stations de ravaitaillement en gaz',
  water:                 '  points d\'eau naturels',
  'swiming pool':        'Points d\'eau artificiels',
  urban:                 'Zones urbaines',
  departements:          'Limites administratives des départements',
  sdis:                  'centres d\'incendie et de secours (SDIS)',
  regions:               'Limites administratives des régions',
};

export const COUNTRY_LABELS = {
  france:  'France',
  tunisia: 'Tunisie',
  spain:   'Espagne',
  italy:   'Italie',
  greece:  'Grèce',
};
export const FORECAST_MIN_DAY = -5;
export const FORECAST_MAX_DAY =  2;
export const FORECAST_DAYS    = [-5, -4, -3, -2, -1, 0, 1, 2];
export const FORECAST_RANGE   = FORECAST_MAX_DAY - FORECAST_MIN_DAY;

export const FRANCE_COUNTRY_ID = 1;
export const AUTH_FORCED_LAYER_NAME = 'login_secufire';

// ── Modules partageant le même intervalle de prévision (ForecastRuler) ──
// "Météo" et "Couches terrain" affichent le même réglage d'intervalle :
// modifier l'un met à jour l'autre, et les deux sont sauvegardés ensemble.
export const FORECAST_LINKED_SERVICES = ['weather', 'display_layers_service'];

// Sur "Couches terrain", l'intervalle de prévision n'est pertinent QUE pour
// la couche DFMC — il ne s'affiche que quand cette couche précise est
// sélectionnée dans le module display_layers_service.
export const DFMC_LAYER_NAME = 'dfmc';
// kkkkkjfhjfnh
